export default __webpack_public_path__ + "static/media/home_1.4f22ecc1.webp";